<template>
  <div v-if="loading" :style="{ height: computedHeight }" class="relative w-full flex flex-col items-center justify-center space-y-3 
           bg-[#ffffff] backdrop-blur-[1px] rounded-lg transition-all duration-300">
    <div class="animate-spin w-[30%] max-w-12 aspect-square border-[3px] border-current border-t-transparent 
             text-blue-500 rounded-full" role="status" aria-label="loading"></div>

    <span v-if="message" class="text-gray-700 text-xs sm:text-sm font-medium text-center px-2 opacity-90">
      {{ message }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'SwdAdaptiveSpinner',
  props: {
    loading: { type: Boolean, default: true },
    message: { type: String, default: 'Loading Data...' },
    rows: { type: [Number, String], default: 6 },
    rowHeight: { type: Number, default: 35 }, 
  },
  computed: {
    computedHeight() {

      return `${this.rows * this.rowHeight}px`
    },
  },
}
</script>

<style scoped>

div[role='status'] {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}


:host,
.relative {
  transition: opacity 0.3s ease, transform 0.3s ease;
}
</style>
